import {
  WorksheetCardImage as WorksheetCardImageStyled,
  WorksheetCardImageWrapper,
} from './worksheet-card.style';
import { useImageLoad } from 'approot/shared/images/images.hooks';

type WorksheetCardImageProps = {
  imageUrl?: string;
  ratio?: number;
  imageIsSquare?: boolean;
};

export const WorksheetCardImage = ({
  imageUrl,
  imageIsSquare,
  ratio,
  ...props
}: WorksheetCardImageProps) => {
  const { imageHasLoaded, isLandscape } = useImageLoad(imageUrl);
  return (
    <WorksheetCardImageStyled
      $imageHasLoaded={imageHasLoaded}
      $isLandscape={imageIsSquare || isLandscape}
      $ratio={ratio}
      {...props}
    >
      <WorksheetCardImageWrapper $isLandscape={imageIsSquare || isLandscape}>
        <img src={imageUrl} alt="" />
      </WorksheetCardImageWrapper>
    </WorksheetCardImageStyled>
  );
};
